import React from 'react'
import useTranslation from '../hooks/useTranslation'
import { CircularSpinner } from './CircularSpinner'
import { FooterModal } from './FooterModal'
import ImageWithBasePath from './ImageWithBasePath'
import { SecondaryButton } from './SecondaryButton'

export const FooterModelForApplyJob = ({
  setIsShowAppiledModel,
  rediretionHandler,
  showIsAppiledModel,
  isApplied,
  loading
}) => {
  const translation = useTranslation()
  return (
    <FooterModal
      isOpen={showIsAppiledModel}
      handleModalClose={() => setIsShowAppiledModel(false)}
      className="pb-[12px]"
    >
      {loading ? (
        <div className="py-[70px]">
          <CircularSpinner />
        </div>
      ) : (
        <div className="mx-[12px] flex flex-col items-center">
          {isApplied && (
            <ImageWithBasePath src="successTick" height={48} width={48} alt="success symbol" />
          )}
          <div className="py-[12px] text-center font-noto-sans text-[18px] font-bold">
            {isApplied
              ? translation.footerModelForApplyJobFields.header2
              : translation.footerModelForApplyJobFields.header1}
          </div>
          {!isApplied && (
            <div className="pb-[20px] text-center font-noto-sans font-bold">
              {translation.footerModelForApplyJobFields.applyConformation}
            </div>
          )}
          <div className="pb-[20px] text-center font-noto-sans">
            {isApplied
              ? translation.footerModelForApplyJobFields.subText1
              : translation.footerModelForApplyJobFields.subText2}
          </div>
          <SecondaryButton
            title={isApplied ? translation.continue : translation.yesApply}
            onClick={() =>
              isApplied ? setIsShowAppiledModel(false) : rediretionHandler({ buttonText: 'Apply' })
            }
            className="border-secondary bg-secondary"
            icon="rightArrowBlack1"
            imageAfterTitle={true}
            imageClass="ml-[6px] mt-[3px]"
          />
          {!isApplied && (
            <div
              className="py-[12px] text-center font-noto-sans"
              onClick={() => setIsShowAppiledModel(false)}
            >
              {translation.cancel}
            </div>
          )}
        </div>
      )}
    </FooterModal>
  )
}
